<script setup>
import { useDisplay } from "vuetify";
import banner from "@images/homepage-banner.png";
import generalBackground from "@images/general-background.png";
import { INSTRUCTION_TEXTS } from "@/utils/constant";

definePage({
  name: "Social",
  meta: {
    layout: "default",
    // public: true,
    requiresAuth: true,
    title: "Ranks & Leaderboards",
    description: "Track top pilots, squads, and your standing across Nexus battles.",
  },
});

const { mobile } = useDisplay();
const router = useRouter();
const authStore = useAuthStore();
const onboarding = useOnboardingStore();

onMounted(() => {
  if (mobile.value) {
    // Redirect to first mobile sub-page (Leaderboard)
    router.push("/ranks/mobile-leaderboard");
    return;
  }

  if (!onboarding.shown.rank) {
    onboarding.showInstruction({
      text: INSTRUCTION_TEXTS.rank,
      onClose: () => onboarding.markShown("rank"),
    });
  }
});

onUnmounted(() => {});
</script>

<template>
  <!-- StarrySky as fixed background -->
  <StarrySky class="" />

  <div class="tw-page-container tw-min-h-screen tw-relative">
    <v-container>
      <div
        class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-[9fr_11fr] tw-gap-4"
      >
        <div class="">
          <my-profile-block />

          <loadout-block />
        </div>

        <v-sheet color="transparent" class="">
          <leaderboard class="tw-mb-4" />
        </v-sheet>

        <!-- <div class="tw-gap-4 tw-relative tw-overflow-hidden"></div> -->
      </div>
    </v-container>

    <!-- <v-overlay
      ref="overlayComingSoonRef"
      class="tw-justify-center tw-items-center !tw-z-[10]"
      v-model="overlayComingSoon"
      contained
      scrim="black"
      persistent
      opacity=".7"
    >
      <v-card class="pa-2" color="transparent" flat>
        <div class="coming-soon-text">Coming soon</div>
      </v-card>
    </v-overlay> -->
  </div>
</template>

<style lang="postcss" scoped>
.coming-soon-text {
  @apply tw-text-3xl tw-font-bold tw-text-center tw-text-white tw-p-6 tw-uppercase;
  color: rgba(5, 248, 0, 0.95);
  text-shadow:
    0 0 10px rgba(5, 248, 0, 0.6),
    0 0 20px rgba(5, 248, 0, 0.4),
    0 0 40px rgba(0, 0, 0, 0.25);
}
</style>
